import { defineStore } from 'pinia';
import { readonly, ref, computed } from 'vue';
import { sum } from '@/js/lib/helper/array';
import { getBaskets, type CartBasket } from '@/js/lib/api/v1/cart';

export const useCartStore = defineStore('cart', () => {
  const baskets = ref<CartBasket[]>([]);
  const itemCount = computed(() => sum(baskets.value.flatMap((basket) => basket.items.map((item) => item.quantity))));
  async function loadBaskets() {
    baskets.value = await getBaskets();
  }

  return { baskets: readonly(baskets), itemCount, loadBaskets };
});
